import $ from 'jquery'
import template from 'templates/department-map.pug'

import Modal from 'garden/src/js/components/modal'
import emitter from 'garden/src/js/utils/emitter'

import BaseComponent from 'scripts/components/base-component'
import { showSpinner, hideSpinner } from 'scripts/utils/spinner'
import REGIONS from 'scripts/constants/regions'

const DEFAULTS = {
  endpoint: 'https://smartmap.leroymerlin.com.br/api/v1',
  messages: {
    internal: 'Erro interno, tente novamente mais tarde'
  },
  texts: {
    errorTitle: 'Ops! Ocorreram os seguintes erros:'
  }
}

class MapsBase extends BaseComponent {
  static componentName = 'maps-base'

  constructor (element, options = {}) {
    super(element)
    this.options = $.extend({}, DEFAULTS, options)
  }

  getStoresByRegion () {
    return REGIONS[this.options.region] || []
  }

  buildModal () {
    const stores = this.getStoresByRegion()
    this.setModal({ stores })
  }

  setModal (templateData) {
    this.modal = this.modal || new Modal(template(templateData)).init()
    this.$modalContent = this.modal.$content

    this.bindShowMapButtons()
    this.bindBackToStores()
  }

  showModal () {
    if (!this.modal) {
      this.buildModal()
    }

    this.modal.show()
  }

  hideModal () {
    if (this.modal) {
      this.modal.hide()
    }
  }

  bindShowMapButtons () {
    const $buttons = this.$modalContent.find('[data-store-id]')
    $buttons.on('click', this.onShowMapClick.bind(this))
  }

  onShowMapClick (event) {
    event.preventDefault()

    const $element = $(event.target)
    this.storeId = $element.data('store-id')
    this.storeLabel = $element.data('store-label')

    this.fetchStoreMap()
  }

  fetchStoreMap () {
    showSpinner()

    const department = +this.options.department
    const url = `/stores/${this.storeId}/last_map/${department}`

    $.get(this.options.endpoint + url)
      .done(this.onFechStoreMapSuccess.bind(this))
      .fail(this.onFechStoreMapFailure.bind(this))
      .always(hideSpinner)
  }

  onFechStoreMapSuccess (response) {
    const imageUrl = response.department_file_url

    if (!imageUrl) {
      return this.onFechStoreMapFailure(response)
    }

    if (!this.modal) {
      this.buildModal()
    }

    this.updateImage(imageUrl)
    this.updateTitle()

    this.showModal()
    this.showMapResult()
  }

  updateImage (imageUrl) {
    const $newMap = $('<object data-image-map />', {
      type: 'image/svg+xml',
      alt: 'Mapa da loja'
    }).attr('data', imageUrl).addClass('image')

    this.$modalContent.find('[data-image-map]').remove()
    this.$modalContent.find('[data-mapa-result]').append($newMap)
  }

  updateTitle () {
    this.$modalContent.find('[data-result-section]').html(this.options.section)
    this.$modalContent.find('[data-result-store]').html(this.storeLabel)
  }

  onFechStoreMapFailure (response) {
    let message = response.message

    if (!message && response.responseJSON) {
      message = response.responseJSON.message
    }

    this.showError(message)
  }

  bindBackToStores () {
    const $back = this.$modalContent.find('[data-back]')
    $back.on('click', this.onBackToStoresClick.bind(this))
  }

  onBackToStoresClick (event) {
    event.preventDefault()
    this.showStoreList()
  }

  showStoreList () {
    this.showModal()
    this.showMapResult(false)
  }

  showMapResult (state = true) {
    this.$modalContent.find('[data-mapa-result]').toggleClass('hidden', !state)
    this.$modalContent.find('[data-store-list]').toggleClass('hidden', state)
  }

  showError (message) {
    hideSpinner()
    this.hideModal()

    emitter.emit('stickyFeedback:error', {
      title: this.options.texts.errorTitle,
      content: message || this.options.messages.internal
    })
  }
}

export default MapsBase
